import { createSlice } from "@reduxjs/toolkit";

import { generateId } from "../../../utils/nanoid";

export interface MessageBoxParams {
  title: string;
  message: string;
  buttonText?: {
    ok?: string;
  };
}

type MessageBoxResult = Record<string, never>;

type ModalType = "message-box";
type ModalParams = MessageBoxParams;
type ModalResult = MessageBoxResult;

interface ModalDef {
  id: string;
  type: ModalType;
  params: ModalParams;
}

export interface ModalsState {
  displayed: ModalDef[];
  results: { [key: string]: ModalResult };
}

const initialState: ModalsState = {
  displayed: [],
  results: {},
};

const slice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    openModal(state, { payload }: { payload: { type: ModalType; params: ModalParams } }) {
      state.displayed.push({ id: generateId(), ...payload });
    },
    closeModal(state, { payload = {} }: { payload: ModalResult }) {
      const modalDef = state.displayed.pop();
      state.results[modalDef.id] = payload;
    },
    clearModalResult(state, { payload }: { payload: string }) {
      delete state.results[payload];
    },
  },
});

export const { openModal, closeModal, clearModalResult } = slice.actions;
export default slice.reducer;
